var _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 480 400",
    id: "Layer_1",
    viewBox: "0 0 480 400",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#262626",
    opacity: 0.3,
    points: "330,355 470,285 150,125 10,195 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "69.3,196.4 119.5,182.4 84.9,162.5 67.4,179.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "261.7,296.2 311.9,282.2 277.2,262.3 259.7,279.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.29,
    points: "69.3,196.4 119.5,182.4 84.9,162.5 67.4,179.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.29,
    points: "261.7,296.2 311.9,282.2 277.2,262.3 259.7,279.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.4,276.3c-6.7-3.4-12.8-3.8-17.3-1.7l0,0l-9.5,5.1l0,0c-4.8,2.2-7.9,7.1-7.9,14.3    c0,13.9,11.3,30.9,25.2,37.8c6.9,3.4,13.1,3.8,17.7,1.6c0,0,9.4-5,10.4-5.6c4.1-2.4,6.6-7.1,6.6-13.6    C323.6,300.2,312.3,283.3,298.4,276.3z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.9,333.3c1.8-0.9,9.2-4.9,10.1-5.5c4.1-2.4,6.6-7.1,6.6-13.6c0-5.6-1.8-11.7-4.9-17.4l-9.5,5.1    c3.1,5.7,4.9,11.8,4.9,17.4C314.2,326.1,311.4,331,306.9,333.3z",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M314.2,319.3c0,13.9-11.3,19.6-25.2,12.6c-13.9-7-25.2-23.9-25.2-37.8s11.3-19.6,25.2-12.6     C302.9,288.4,314.2,305.4,314.2,319.3z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,316.5c0,10.9-8.8,15.3-19.7,9.9c-10.9-5.4-19.7-18.7-19.7-29.6c0-10.9,8.8-15.3,19.7-9.9     C299.8,292.4,308.6,305.6,308.6,316.5z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.9,325.3c3-1.7,4.8-5,4.8-9.7c0-0.4,0-0.8,0-1.1l-11-1.7L301.9,325.3z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.1,303.6l11.5,2.5c-2.4-5.7-6.7-11.3-11.9-14.9L293.1,303.6z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8,299.5l0.4-12c-5.2-1.5-9.5-0.3-11.9,3L284.8,299.5z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2,296.7c0,0.4,0,0.7,0,1.1c0,4.7,1.8,9.8,4.8,14.5l6.3-6.2L271.2,296.7z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.9,314.2l-6.8,5.5c2.1,1.9,4.4,3.5,6.8,4.7c2.4,1.2,4.7,1.9,6.8,2L288.9,314.2z",
    fill: "#2D3134"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,319.3c0,13.9-11.3,19.6-25.2,12.6s-25.2-23.9-25.2-37.8s11.3-19.6,25.2-12.6    C302.9,288.4,314.2,305.4,314.2,319.3z",
    opacity: 0.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.2,179.6c-6.7-3.4-12.8-3.8-17.3-1.7l0,0l-9.5,5.1l0,0c-4.8,2.2-7.9,7.1-7.9,14.3    c0,13.9,11.3,30.9,25.2,37.8c6.9,3.4,13.1,3.8,17.7,1.6c0,0,9.4-5,10.4-5.6c4.1-2.4,6.6-7.1,6.6-13.6    C131.5,203.5,120.2,186.6,106.2,179.6z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,236.6c1.8-0.9,9.2-4.9,10.1-5.5c4.1-2.4,6.6-7.1,6.6-13.6c0-5.6-1.8-11.7-4.9-17.4l-9.5,5.1    c3.1,5.7,4.9,11.8,4.9,17.4C122,229.4,119.2,234.2,114.8,236.6z",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122,222.5c0,13.9-11.3,19.6-25.2,12.6c-13.9-7-25.2-23.9-25.2-37.8c0-13.9,11.3-19.6,25.2-12.6     C110.7,191.7,122,208.6,122,222.5z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,219.8c0,10.9-8.8,15.3-19.7,9.9s-19.7-18.7-19.7-29.6c0-10.9,8.8-15.3,19.7-9.9     S116.5,208.9,116.5,219.8z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.8,228.5c3-1.7,4.8-5,4.8-9.7c0-0.4,0-0.8,0-1.1l-11-1.7L109.8,228.5z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,206.8l11.5,2.5c-2.4-5.7-6.7-11.3-11.9-14.9L100.9,206.8z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7,202.7l0.4-12c-5.2-1.5-9.5-0.3-11.9,3L92.7,202.7z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,199.9c0,0.4,0,0.7,0,1.1c0,4.7,1.8,9.8,4.8,14.5l6.3-6.2L79.1,199.9z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8,217.5l-6.8,5.5c2.1,1.9,4.4,3.5,6.8,4.7c2.4,1.2,4.7,1.9,6.8,2L96.8,217.5z",
    fill: "#2D3134"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122,222.5c0,13.9-11.3,19.6-25.2,12.6s-25.2-23.9-25.2-37.8c0-13.9,11.3-19.6,25.2-12.6    C110.7,191.7,122,208.6,122,222.5z",
    opacity: 0.11
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441,221c-19.3-17.2-102.5-82.6-116.4-92.9c-13.9-10.3-64.2-41.9-98-50.6c-33.8-8.7-38-3.6-44.9-5.1   c-6.9-1.5-27.4-6.3-57.6,3c-12.9,4-28.2,8.4-40.7,19.6c-16.6,14.8-29.4,37.8-35.6,50.3l-1.3,4.2c-2.3,7.5-1.3,15.7,2.7,22.4   c3.4,5.7,7.7,12.3,10.9,15.9c2.8,3.1,6.2,6.4,9.1,9.2c0-0.2,0-0.5,0-0.7c0-10.6,6.2-17.4,15.8-17.4c3.8,0,7.9,1.1,12.1,3.2   c14.5,7.2,26.2,24.9,26.2,39.4c0,1.9-0.2,3.7-0.6,5.4l138.9,69.4c-0.1-1.1-0.2-2.2-0.2-3.2c0-10.6,6.2-17.4,15.8-17.4   c3.8,0,7.9,1.1,12.1,3.2c14.5,7.2,26.2,24.9,26.2,39.4c0,1.7-0.2,3.2-0.5,4.7l11.1,5.5c0,0,20.8,5.4,34.1,4.2   c13.3-1.2,40.7-10.2,62.7-21.1c22-10.9,40.6-30.1,41-40.1C464.1,267.7,460.3,238.2,441,221z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.8,162.5c0,0-1.2-8.4,0-10.6c1.2-2.1,3.3-5.4,6-3c2.7,2.4,5.7,9.3,3,15.7   C370.1,171,363.8,162.5,363.8,162.5z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,129.7c0,0,64.4,44.5,138.4,84.3s112.9,62.4,112.9,62.4l-45.7-39.2l-163.9-95.6   L58.8,129.7z",
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,142.6l162.2,94.7c0,0-15.7-69-71.1-96.8S102.1,142.6,102.1,142.6z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,91.4c21.6-10.2,39.2-13.3,39.2-15.4c0-2.1-55.5-4.8-89.8,12.4s-32.6,32-19.6,30.4s30.4-3,35.9-5.7   S151.3,100.1,169.7,91.4z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,116.5c-1.3,0-4.4-0.3-4.9-2.6c-0.8-3.4,3.8-12.9,27.1-24.5c25.5-12.7,61.4-13.7,71.8-13.7   c5.3,0,9.3,0.2,12,0.5c-1.4,0.5-2.9,1-4.5,1.5c-7.2,2.3-18.1,5.8-30.2,11.6c-12.3,5.8-21.3,12.5-27.2,16.8c-3.1,2.2-5.5,4-7.2,4.9   c-4.2,2.1-17.2,3.5-28.6,4.8c-2.3,0.3-4.6,0.5-6.7,0.7C99.9,116.5,99.4,116.5,98.9,116.5L98.9,116.5z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,169.5c-2,5.5,30.1,59.7,40.1,62.4c9.9,2.7,39.8,1.8,69.3-14.5c29.5-16.3,35-28.9,33.5-33.5   c-1.5-4.5-58.2-52.2-67.5-53.1S246.8,162.8,244.4,169.5z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.1,287c0,0,4.2-5.6,15.5-6.9c11.3-1.2,25.1-0.1,35.4,9.1c7.7,6.9,10.5,9.8,10.5,9.8   s-21.8,7.1-32.6,5.6C341.2,303.1,323.1,287,323.1,287z",
    fill: "#FFFFFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2,285.1c0,0,3.9-5.2,14.3-6.3s23.2-0.1,32.7,8.4c7.1,6.3,9.7,9,9.7,9s-20.1,6.6-30.1,5.2   S325.2,285.1,325.2,285.1z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.4,267.4c0,0,15.2-14.2,14.4-18.2c-0.8-4.1-12.5-24.3-14-21.3s-4.7,7.8-3.5,11.9   C442.5,243.9,444.7,263.8,444.4,267.4z",
    fill: "#FFFFFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.3,264.6c0,0,14.3-14.2,13.6-18.2c-0.8-4.1-12.5-24.3-14-21.3c-1.5,3-4.7,7.8-3.5,11.9   C441.6,241,444.6,260.9,444.3,264.6z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.7,324.5l-0.5,4.4c0,0,44.7-5.7,72.8-23c28-17.3,34.8-30.8,34.8-30.8s-21.6,23.4-48,34.2   C385.1,320.5,353.7,324.5,353.7,324.5z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.9,180.2c-5.1-4.9-14.8-13.5-27.1-23.4c-20-16.2-31.7-23.7-34.5-23.9c0,0-0.1,0-0.1,0   c-4.1,0-20.4,6.8-38.6,16.2c-20.9,10.7-32.1,18.3-33.7,20.6c0.2,2.8,5.7,14.7,15.9,31.1c11.3,18.1,19.5,27.1,22.2,27.9   c1.5,0.4,3.4,0.7,5.6,0.9c13.2-2,36-7.1,58.2-20.2C367.6,198.3,376.6,187.6,380.9,180.2z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,138.8l-2.1,6.3l62.4,36.4l10-40.2l-0.3-0.4c-13.2-5.8-26.2-8.7-38.9-8.7   C133.6,132.3,123,135.6,115.8,138.8z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.3,223.1l2.5-15.3c-1.1-2.3-2.2-4.6-3.5-7c-9.4-17.8-26-41.7-52.3-55.8l0,0l-6.2,43.3L247.3,223.1z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2,169.6c0,2.9-2.4,4.1-5.3,2.7c-2.9-1.5-5.3-5-5.3-8s2.4-4.1,5.3-2.7   C123.8,163.1,126.2,166.6,126.2,169.6z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4,160.6l-2.3,2.6c0,0,16.7,10.9,18.2,8.7C129.9,169.8,112.4,160.6,112.4,160.6z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4,210.1c0,2.9-2.4,4.1-5.3,2.7c-2.9-1.5-5.3-5-5.3-8c0-2.9,2.4-4.1,5.3-2.7   C195,203.6,197.4,207.1,197.4,210.1z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,201l-2.3,2.6c0,0,16.7,10.9,18.2,8.7C201.1,210.2,183.6,201,183.6,201z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.9,237.2c0,0.1-1.8,7-3.3,15.4c-1.4,7.6-2.2,32.8-2.4,37.3l-79.6-40.3c-0.1-1.6-1.2-16.5-1.2-30.1   c0-14.3,3.6-30.2,3.6-30.3l-0.9-0.2c0,0.2-3.6,16.2-3.6,30.5c0,12.6,0.9,26.4,1.2,29.6l-39.6-20c-0.9-1.2-10.5-14.3-19.9-34.2   c-9.7-20.5-7.4-46.5-7.3-46.8l-0.9-0.1c0,0.3-2.4,26.5,7.4,47.3c9.9,20.8,20,34.3,20.1,34.4l0.1,0.1L259,291.4l0-0.7   c0-0.3,0.9-29.6,2.4-37.9c1.5-8.3,3.3-15.3,3.3-15.3L263.9,237.2z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,286.2c0,3.6-2.9,7.9-6.5,9.7s-6.5,0.3-6.5-3.2c0-3.6,2.9-7.9,6.5-9.7S359.1,282.6,359.1,286.2z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.1,288.8c0,2.5-2,5.5-4.5,6.8c-2.5,1.2-4.5,0.2-4.5-2.3c0-2.5,2-5.5,4.5-6.8   C367.1,285.3,369.1,286.3,369.1,288.8z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.7,292.1c0,1.3-1.1,3-2.4,3.6c-1.3,0.7-2.4,0.1-2.4-1.2s1.1-3,2.4-3.6   C343.6,290.2,344.7,290.7,344.7,292.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,288.9c0,1.8-1.5,4-3.2,4.9c-1.8,0.9-3.2,0.2-3.2-1.6s1.5-4,3.2-4.9   C354.9,286.4,356.4,287.1,356.4,288.9z",
    fill: "#FFFFFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.4,290.6c0,1.3-1.1,3-2.4,3.6c-1.3,0.7-2.4,0.1-2.4-1.2s1.1-3,2.4-3.6   C366.3,288.7,367.4,289.3,367.4,290.6z",
    fill: "#FFFFFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.1,284c0,1.3-1.1,3-2.4,3.6c-1.3,0.7-2.4,0.1-2.4-1.2s1.1-3,2.4-3.6C340,282.1,341.1,282.7,341.1,284z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,231.4c0,1.3-1.1,3-2.4,3.6c-1.3,0.7-2.4,0.1-2.4-1.2c0-1.3,1.1-3,2.4-3.6   C446.9,229.5,448,230,448,231.4z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5,237.7c0,1.3-1.1,3-2.4,3.6c-1.3,0.7-2.4,0.1-2.4-1.2s1.1-3,2.4-3.6   C451.4,235.8,452.5,236.4,452.5,237.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.9,241.9c0,3.1-2.5,6.8-5.6,8.3s-5.6,0.3-5.6-2.8s2.5-6.8,5.6-8.3C451.4,237.6,453.9,238.9,453.9,241.9z   ",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.6,245.2c0,1.6-1.3,3.5-2.8,4.3c-1.6,0.8-2.8,0.1-2.8-1.4s1.3-3.5,2.8-4.3   C449.3,243,450.6,243.6,450.6,245.2z",
    fill: "#FFFFFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.4,250.3c0-2.5-2-3.5-4.5-2.3c-0.8,0.4-1.5,0.9-2.1,1.6c0.4,2.7,0.8,5.5,1.1,7.9   c0.3-0.1,0.7-0.2,1.1-0.4C447.4,255.9,449.4,252.8,449.4,250.3z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2,285c4.9-0.4,18.7-1.1,27.4,1c8.7,2.1,23.8,7.9,29.2,10.1c-0.6-0.6-3.4-3.4-9.6-8.9   c-9.5-8.5-22.3-9.5-32.7-8.4C330,279.8,325.9,284.2,325.2,285z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.7,212.9c0,0,7.5,3.6,10.9,8.1c3.3,4.5,3.3,6.9,3.3,6.9s-20.8,4.5-31.1-2.1   C213.9,218.7,241.7,212.9,241.7,212.9z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "296.4,230.3 300.2,230 335.2,213 337.1,209.5 358.4,199.6 357.5,197.9 316.8,216 318,217.5    333.8,210.5 332.9,211.5 298.7,227.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "333.4,220.9 336.7,220.9 364.6,200.2 368,192.2 378.7,178.6 378,177.6 357.9,200.5 358.7,201.7    364.1,196.9 362.6,199.6 334.3,219.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.6,286.9l11.6,10.4c0,0,16.8-3.2,31.8-10.9c15-7.7,24-18.1,24-18.1l-1.2-15.2c0,0-6.8,12.3-26.4,22   C398,283.8,375.6,286.9,375.6,286.9z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.2,308.9c21.9-11,40.6-29.6,41-39.6c0.1-1.7,0.2-4.5-2.2-12.4c-0.2-0.7-1.1-0.8-1.5-0.2   c-7.7,11-20.8,25.3-41.2,35.1c-21.2,10.2-47.2,18.9-67.2,17.9c-4.7-0.2-5.5,4.5-5.9,11.9c-0.2,4.8,3.8,8.8,8.6,8.3   C371,328.2,398.6,320.7,422.2,308.9z",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,148.5c0,0,6.3-16.1,9.8-21.1c3.5-5,7.4-9.5,7.4-9.5l-1.1-3c0,0-7.4,2.6-8.7,4.8   c-1.4,2.3-8.9,25.6-8.9,25.6L49.4,148.5z",
    fill: "#CC291F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,183.1c0.7-1,1.3-2,1.8-2.9c-5.1-4.9-14.8-13.5-27.1-23.4c-20-16.2-31.7-23.7-34.5-23.9c0,0-0.1,0-0.1,0   c-4.1,0-20.4,6.8-38.6,16.2c-20.9,10.7-32.1,18.3-33.7,20.6c0.1,0.9,0.7,2.9,1.9,5.6C291.4,161.5,338.1,164.2,379,183.1z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5E5E5",
    points: "408.4,303.2 408.4,317.8 434.7,304.7 434.7,290.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.3,264.6c0,0,14.3-14.2,13.6-18.2c-0.8-4.1-12.5-24.3-14-21.3c-1.5,3-4.7,7.8-3.5,11.9   C441.6,241,444.6,260.9,444.3,264.6z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,173.9c-3.2-7.9-25.4-33.1-50-45.2c-31-15.2-58-15.2-63.5-14.4l-0.2-1.3c5.6-0.8,33-0.8,64.3,14.5   c10.9,5.3,22.7,14,33.4,24.4c8.5,8.2,15.4,16.9,17.3,21.5L245.8,173.9z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,135l-0.1-0.1c-10-7.3-36.7-26.7-61.3-38.7c-30.9-15.1-55-19.8-60.3-19.8V75c5.4,0,29.8,4.7,60.9,20   c24.7,12.1,51.4,31.5,61.5,38.8l0.1,0.1L325.1,135z",
    fill: "#2D3134"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "140,200 140,210 150,215 150,205   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "160,200 150,195 150,205 160,210   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "150,225 160,230 160,220 150,215   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "160,210 160,220 170,225 170,215   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "180,210 170,205 170,215 180,220   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "170,235 180,240 180,230 170,225   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "180,220 180,230 190,235 190,225   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "200,220 190,215 190,225 200,230   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "190,245 200,250 200,240 190,235   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "200,230 200,240 210,245 210,235   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "240,250 240,260 250,265 250,255   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "240,240 230,235 230,245 240,250   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "230,265 240,270 240,260 230,255   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "220,240 220,250 230,255 230,245   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "220,230 210,225 210,235 220,240   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "210,255 220,260 220,250 210,245   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "218,129 266,105 248,96 201,120    "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,86.4l-31,15.5c-1.4,0.7-2.5,1.8-3.2,3.3l-6,12.8l14,7l44-22l-6.9-12.9c-0.7-1.4-1.9-2.5-3.4-3.1     l-1.8-0.8C248.1,85.5,246,85.5,244.1,86.4z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5,105.3l-5-2.2c-0.6,0.6-1.1,1.2-1.4,2l-6,12.8l14,7v-17.3C218,106.7,217.4,105.7,216.5,105.3z",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.1,90.1c-0.4-0.7-0.9-1.4-1.5-1.9l-32.8,16.4c-1.7,0.8-2.7,2.6-2.7,4.4V125l44-22L255.1,90.1z",
    opacity: 0.29
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2D3134",
    points: "254,103 224,118 224,108 250,95   "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.2,295.8c-7-7.9-47-49.9-57.4-66.3c-13.6-21.3-35.8-73.4-76.7-92.9c-41-19.5-87.4-11.2-101.4-10.2   c-8.5,0.5-21.7-2.6-30.9-5.2c-6,9.1-10.7,17.9-13.8,24.2l-1.3,4.2c-2.3,7.5-1.3,15.7,2.7,22.4c3.4,5.7,7.7,12.3,10.9,15.9   c2.8,3.1,6.2,6.4,9.1,9.2c0-0.2,0-0.5,0-0.7c0-10.6,6.2-17.4,15.8-17.4c3.8,0,7.9,1.1,12.1,3.2c14.5,7.2,26.2,24.9,26.2,39.4   c0,1.9-0.2,3.7-0.6,5.4l138.9,69.4c-0.1-1.1-0.2-2.2-0.2-3.2c0-10.6,6.2-17.4,15.8-17.4c3.8,0,7.9,1.1,12.1,3.2   c14.5,7.2,26.2,24.9,26.2,39.4c0,1.7-0.2,3.2-0.5,4.7l11.1,5.5c0,0,5.8,1.5,13.2,2.8C337.7,316.7,334,302.4,328.2,295.8z",
    opacity: 0.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.2eac81ba091d5000fe9b4153c8267f90.svg";
export { ForwardRef as ReactComponent };